import { useState } from 'react';
import { SlidersHorizontal, ChevronDown } from 'lucide-react';
import { Button } from './ui/button';

export const CollapsibleFilters = ({ search, children, activeCount = 0, testId }) => {
  const [open, setOpen] = useState(false);
  return <div className="mobile-filter-bar" data-testid={testId}>
    <div className="mobile-filter-search">{search}</div>
    <Button variant="outline" className="mobile-filter-toggle" onClick={() => setOpen(!open)}
      aria-expanded={open} aria-controls={`${testId}-fields`} data-testid={`${testId}-toggle`}>
      <SlidersHorizontal className="h-4 w-4" /> Filters{activeCount > 0 ? ` (${activeCount})` : ''}
      <ChevronDown aria-hidden="true" className={`h-3 w-3 transition-transform ${open ? 'rotate-180' : ''}`} />
    </Button>
    <div id={`${testId}-fields`} className="mobile-filter-fields" data-open={open}>{children}</div>
  </div>;
};